import React from 'react';
import styled from 'styled-components';

type copyType = 'figcaption' | 'p' | 'div';

export interface CopyProps {
  className?: string;
  children: React.ReactNode;
  as?: copyType;
}

const StyledCopy = styled.p`
  margin: 0 0 var(--distance-m);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xs);
  line-height: var(--line-height-xs);

  a {
    color: var(--color-text-primary);
    font-weight: var(--font-weight-bold);
    text-underline-offset: 2px;
  }
`;

const Copy = ({ className, children, as = 'p' } : CopyProps) => (
  <StyledCopy as={as} className={className}>{children}</StyledCopy>
);

export default Copy;
